"use strict";

/**
 * Check if the date is already at the beginning of the snapDates unit.
 */
const isStartOfSnapUnit = (date, snapDates) =>
  date.valueOf() === date.startOf(snapDates).valueOf();

module.exports = isStartOfSnapUnit;
